var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCustomerStoriesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.531,
    height: 27.01,
    viewBox: "0 0 29.531 27.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "book",
    transform: "translate(-2 -3.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3112",
    "data-name": "Path 3112",
    d: "M27,52h3.164v1.582H27Z",
    transform: "translate(-11.816 -22.791)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3113",
    "data-name": "Path 3113",
    d: "M27,48h3.164v1.055H27Z",
    transform: "translate(-11.816 -20.9)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3114",
    "data-name": "Path 3114",
    d: "M19.473,11.807C19.04,9.943,16.436,6.276,9.7,3.812a.506.506,0,0,0-.47.065A.524.524,0,0,0,9,4.313v3.66l8.714,4.182a1.049,1.049,0,0,1,.778-.349Z",
    transform: "translate(-3.309)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3115",
    "data-name": "Path 3115",
    d: "M27,26h3.164v1.055H27Z",
    transform: "translate(-11.816 -10.502)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3116",
    "data-name": "Path 3116",
    d: "M2.527,11.176a.527.527,0,0,0-.28.082A.519.519,0,0,0,2,11.7V27.294a.532.532,0,0,0,.3.475l11.83,5.68V16.688L2.756,11.229a.532.532,0,0,0-.228-.053Zm6.8,9.635a.527.527,0,0,1-.708.236L5.458,19.465a.528.528,0,0,1,.471-.944L9.094,20.1A.527.527,0,0,1,9.33,20.811Zm-5.168-5.2a.527.527,0,0,1,.7-.258l6.855,3.164a.527.527,0,0,1-.442.958L4.42,16.308a.527.527,0,0,1-.262-.7Z",
    transform: "translate(0 -3.495)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3117",
    "data-name": "Path 3117",
    d: "M27,30h3.164v8.438H27Z",
    transform: "translate(-11.816 -12.392)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3118",
    "data-name": "Path 3118",
    d: "M40,27.879l6.855-3.2V20.57L40,23.769Z",
    transform: "translate(-17.961 -7.935)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3119",
    "data-name": "Path 3119",
    d: "M27,21h3.164v1.582H27Z",
    transform: "translate(-11.816 -8.138)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3120",
    "data-name": "Path 3120",
    d: "M46.883,11.258a.519.519,0,0,0-.509-.03L35,16.688v16.76L46.83,27.77a.532.532,0,0,0,.3-.475V11.7a.519.519,0,0,0-.246-.447Zm-1.336,8.981a1.058,1.058,0,0,1-.609.956l-6.855,3.2a1.055,1.055,0,0,1-1.5-.956v-4.11a1.058,1.058,0,0,1,.609-.956l6.855-3.2a1.055,1.055,0,0,1,1.5.956Z",
    transform: "translate(-15.598 -3.495)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3121",
    "data-name": "Path 3121",
    d: "M41.614,4.313a.524.524,0,0,0-.229-.436.506.506,0,0,0-.47-.065c-6.736,2.464-9.34,6.13-9.773,7.995h.98a1.049,1.049,0,0,1,.778.349l8.714-4.182Z",
    transform: "translate(-13.774 0)",
    fill: "#7dbaab"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerStoriesIcon);
export default __webpack_public_path__ + "static/media/customer_stories_icon.70312f2569b104dad8b429def4dcc70b.svg";
export { ForwardRef as ReactComponent };